import React from 'react';
import '../styles/Footer.css'; // Optional CSS styling

const Footer = () => {
  const year = new Date().getFullYear();

  return (
    <footer className="site-footer">
      <div className="footer-links">
        <a href="/about">About</a>
        <a href="/api-usage">API Usage</a>
        <a href="https://jessai.nl" target="_blank" rel="noopener noreferrer">Jessai.nl</a>
        <a href="https://discover.y02.nl" target="_blank" rel="noopener noreferrer">Discover</a>
      </div>
      <div className="footer-copy">
        © Jessai Schonewille {year} • v0.1.0
      </div>
    </footer>
  );
};

export default Footer;
